import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [displayChildren, setDisplayChildren] = useState(children);
  const location = useLocation();

  useEffect(() => {
    // Step 1: Start fade out
    setIsVisible(false);
    
    // Step 2: After fade out completes, scroll to top and load new content
    const fadeOutTimer = setTimeout(() => {
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'instant' });
      
      // Load new content
      setDisplayChildren(children);
      
      // Step 3: Fade in new content immediately to prevent navigation delays
      setIsVisible(true);
    }, 150); // Reduced delay for faster navigation

    return () => clearTimeout(fadeOutTimer);
  }, [location.pathname, children]);

  return (
    <div
      style={{
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        minHeight: '100vh',
      }}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition; 